import { domClassMerge } from '@propertyfinder/helpers';
import { IconSpriteStarTrophyFilled } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { AgentAvatarSizeEnum } from 'common/module/agent/avatar/size.enum';
import { AgentAvatarTemplatePropsInterface } from 'common/module/agent/avatar/template-props.interface';
import { AgentAvatarTypeEnum } from 'common/module/agent/avatar/type.enum';
import { LazyLoadingComponent } from 'common/module/lazy-loading/component';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';

export const AgentAvatarTemplate: FunctionalComponent<AgentAvatarTemplatePropsInterface> = ({
  image,
  name,
  size = AgentAvatarSizeEnum.small,
  type = AgentAvatarTypeEnum.default,
  showBorder = false,
  visible = true,
}) => (
  <div className={domClassMerge('agent-avatar', `agent-avatar__${size}`, showBorder ? 'agent-avatar__active' : '')}>
    <LazyLoadingComponent visible={visible} className='agent-avatar__container'>
      <ProgressiveImageComponent
        classname='agent-avatar__image'
        src={image}
        alt={name}
        title={name}
        placeholder={__('assets/common/agent-tile-placeholder.jpg')}
        preloader={__('assets/common/image-loader.svg')}
        webpPlaceholder={__('assets/common/agent-tile-placeholder.webp')}
      />
    </LazyLoadingComponent>
    {type === AgentAvatarTypeEnum.superAgent && (
      <div className={domClassMerge('agent-avatar__icon-container', `agent-avatar__icon-container-${size}`)}>
        <IconSpriteStarTrophyFilled className='agent-avatar__icon' />
      </div>
    )}
  </div>
);
